import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import Drawer from "@mui/material/Drawer";
import React, { useState } from "react";

import FloatingMenuButton from "../Buttons/FloatingMenuButton";
import MenuDrawer from "../MenuDrawer/MenuDrawer";

const Footer = ({ showMenuButton, styles = {} }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  return (
    <div
      // className="row"
      style={{
        position: "absolute",
        top: 20,
        right: 25,
        height: "10vh",
        // width: "10%",
        // display: "flex",
        // justifyContent: "flex-start",
        // paddingLeft: "2vw",
        // margin: "0",
        // marginTop: "2rem",
        zIndex: 5000,
        ...styles,
      }}
    >
      {showMenuButton && (
        <Drawer
          anchor={"left"}
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          transitionDuration={500}
          variant={"temporary"}
          sx={{
            zIndex: 1000,
            position: "relative",
          }}
          PaperProps={{
            style: {
              backgroundColor: theme.COLORS.BLUE.darkBlueGreen,
              borderRadius: "0 66px 66px 0",
            },
          }}
        >
          <MenuDrawer closeDrawer={() => setIsDrawerOpen(false)}></MenuDrawer>
        </Drawer>
      )}
      {showMenuButton && (
        <FloatingMenuButton
          setIsDrawerOpen={setIsDrawerOpen}
        ></FloatingMenuButton>
      )}
    </div>
  );
};

export default Footer;
